var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphMinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M7.67055 4C10.2968 2.11192 13.5186 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17C1 15.6188 1.17501 14.2785 1.50407 13M8 10V11.2162M25 25H10.8333C9.26853 25 8 23.7208 8 22.1429V14.8649M23.8828 11.743L25 10M10.4792 22.3913L15.1835 15.2195C15.8202 14.198 17.0709 14.0551 17.8996 14.9317L18.8588 15.9345C19.6866 16.8 20.9381 16.6682 21.5749 15.6467L22.5368 14.0806"
})));
export default SvgGraphMinline;